
import React from 'react'
import { useGLTF } from '@react-three/drei'

export function VersaldhuSkin(pos) {
  const { nodes, materials } = useGLTF('/models/versal2-transformed.glb')
  return (
    <group position={[pos[0], pos[1], pos[2] - 0.8]} dispose={null} rotation={[Math.PI, Math.PI / 2, 0]}>
      <mesh geometry={nodes['EPCB0039-V01_versal002'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['EPCB0039-V01_versal002_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/versal2-transformed.glb')
